import { render, staticRenderFns } from "./DsField.vue?vue&type=template&id=79d8edc6&scoped=true&"
import script from "./DsField.vue?vue&type=script&lang=js&"
export * from "./DsField.vue?vue&type=script&lang=js&"
import style0 from "./DsField.vue?vue&type=style&index=0&id=79d8edc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8edc6",
  null
  
)

export default component.exports